import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../utils/storage/stores/store";
import { useEffect } from "react";

/**
 * Загрузка данных
 * @param children 
 * @returns 
 */
export const LoadData = ({
    children,
    reducerName,
    resourceName,
    loader,
    preloader,
    necessaryUpdate = false,
    updatedField = null,
}: {
    children: React.ReactNode,
    reducerName: string,
    resourceName: string,
    loader: () => any,
    preloader?: React.ReactNode,
    necessaryUpdate?: boolean,
    updatedField?: string | null
}) => {
    const dispatch = useAppDispatch();
    const reducer = useSelector((state: RootState) => state[reducerName as keyof RootState]);

    const data = reducer[resourceName as keyof typeof reducer];
    
    let watchingField = data;
    if (updatedField && data && data[updatedField as keyof typeof data]) {
        watchingField = data[updatedField as keyof typeof data];
    }
    

    const isLoading = reducer.loading[resourceName as keyof typeof reducer.loading] as boolean;
    const error = reducer.error[resourceName as keyof typeof reducer.error] as string | null;

    //Загрузка данных
    useEffect(() => {
        if (necessaryUpdate) {
            dispatch(loader());
        } else if (Array.isArray(watchingField) && watchingField.length === 0) {
            dispatch(loader());
        } else if (!watchingField) {
            dispatch(loader());
        }
    }, []);

    //Обработка ошибки
    if (error) {
        //TODO: обработка ошибки
    };

    //Загрузка данных
    if (isLoading && preloader) {
        return preloader;
    }

    return children;
};